<script>
import { Doughnut, mixins } from "vue-chartjs";
const { reactiveProp } = mixins;

export default {
  extends: Doughnut,
  mixins: [reactiveProp],
  name: "donut-chart",
  props: ["options"],
  mounted() {
    this.renderChart(this.chartdata, this.options);
  },
  watch: {
    chartData() {
      this.$data._chart.update();
    },
  },
};
</script>